import { OnboardingFormDetails } from "../../slices/onboarding-form/Types";

export const onboardingFormSagaActionTypes = {
  callGetOnboardingDetailListSaga: "callGetOnboardingDetailListSaga",
  callAddOnboardingDetailSaga: "callAddOnboardingDetailSaga",
  callUpdateOnboardingDetailSaga: "callUpdateOnboardingDetailSaga",
  callDeleteOnboardingDetailSaga: "callDeleteOnboardingDetailSaga",
  callGetOnboardingDetailByIdSaga: "callGetOnboardingDetailByIdSaga",
  callUpdateProjectNameSaga: "callUpdateProjectNameSaga",
  callGetFileViewUrlSaga: "callGetFileViewUrlSaga",
};

export const getOnboardingDetailListSagaAction: (partnerID: number) => {
  type: string;
  partnerID: number;
} = (partnerID) => {
  return {
    type: onboardingFormSagaActionTypes.callGetOnboardingDetailListSaga,
    partnerID: partnerID,
  };
};

export const addOnboardingDetailSagaAction: (payload: OnboardingFormDetails) => {
  type: string;
  payload: OnboardingFormDetails;
} = (payload) => {
  return {
    type: onboardingFormSagaActionTypes.callAddOnboardingDetailSaga,
    payload: payload,
  };
};

export const updateOnboardingDetailSagaAction: (
  payload: OnboardingFormDetails
) => {
  type: string;
  payload: OnboardingFormDetails;
} = (payload) => {
  return {
    type: onboardingFormSagaActionTypes.callUpdateOnboardingDetailSaga,
    payload: payload,
  };
};

export const deleteOnboardingDetailSagaAction: (payload: {
  ID: number;
  partnerID: number;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  type: string;
  payload: {
    ID: number;
    partnerID: number;
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  };
} = (payload) => {
  return {
    type: onboardingFormSagaActionTypes.callDeleteOnboardingDetailSaga,
    payload: payload,
  };
};

export const getOnboardingDetailByIdSagaAction: (onboardingID: number) => {
  type: string;
  onboardingID: number;
} = (onboardingID) => {
  return {
    type: onboardingFormSagaActionTypes.callGetOnboardingDetailByIdSaga,
    onboardingID: onboardingID,
  };
};

export const updateProjectNameSagaAction: (payload: {
  old_project_name: string;
  new_project_name: string;
  setEditProjectName: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  type: string;
  payload: {
    old_project_name: string;
    new_project_name: string;
    setEditProjectName: React.Dispatch<React.SetStateAction<boolean>>;
  };
} = (payload) => {
  return {
    type: onboardingFormSagaActionTypes.callUpdateProjectNameSaga,
    payload: payload,
  };
};

export const getFileViewUrlSagaAction: (
  fileKey: string,
  fileType?: string
) => {
  type: string;
  fileKey: string;
  fileType: string;
} = (fileKey, fileType = "view") => {
  return {
    type: onboardingFormSagaActionTypes.callGetFileViewUrlSaga,
    fileKey: fileKey,
    fileType: fileType,
  };
};
